import type { QueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Canonical sign-out: cancel in-flight queries → drop cache → clear session →
 * navigate to /auth via caller. Stops 401 storms and keeps protected data off
 * the back stack. See tanstack-auth-guards "Sign-Out Hygiene".
 */
export async function performSignOut(queryClient: QueryClient): Promise<void> {
  await queryClient.cancelQueries();
  queryClient.clear();
  await supabase.auth.signOut();
}